import {createReducer} from '../utility'


export const certificates = createReducer({},{
    "VERIFY_CERTIFICATE_SUCCESSFULL"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})